import Konva from 'konva';
import GraphicBase from './base';

class GraphicPolygon extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = false;
  }

  build() {
    const { stage } = this;
    const points = [];

    this.data.forEach((pid) => {
      points.push(stage.pointDict[pid].x, stage.pointDict[pid].y);
    });

    this.ele = new Konva.Line({
      id: this.id,
      points,
      stroke: 'blue',
      strokeWidth: 10,
      closed: true,
    });

    this.ele.on('click', (e) => {
      stage.pointClickHandler(e);
    });

    stage.lineLayer.add(this.ele);
    this.layer = stage.lineLayer;

    return this.ele;
  }
}

export default GraphicPolygon;
